import { render, staticRenderFns } from "./CustomDesignTab.vue?vue&type=template&id=d3999b36&scoped=true"
import script from "./CustomDesignTab.vue?vue&type=script&lang=js"
export * from "./CustomDesignTab.vue?vue&type=script&lang=js"
import style0 from "./CustomDesignTab.vue?vue&type=style&index=0&id=d3999b36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3999b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3999b36')) {
      api.createRecord('d3999b36', component.options)
    } else {
      api.reload('d3999b36', component.options)
    }
    module.hot.accept("./CustomDesignTab.vue?vue&type=template&id=d3999b36&scoped=true", function () {
      api.rerender('d3999b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cardSystem/saleToos/projectDelivery/components/applyForm/CustomDesignTab.vue"
export default component.exports